import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  notificationService,
  Notification,
} from '../../services/notifications';
import NotificationToast from './NotificationToast';

const NotificationContainer: React.FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [notificationHeights, setNotificationHeights] = useState<
    Record<string, number>
  >({});
  const notificationRefs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    const unsubscribe = notificationService.subscribe(setNotifications);
    return unsubscribe;
  }, []);

  const handleCloseNotification = (id: string) => {
    notificationService.removeNotification(id);
    // Clean up refs and heights for removed notification
    delete notificationRefs.current[id];
    setNotificationHeights((prev) => {
      const newHeights = { ...prev };
      delete newHeights[id];
      return newHeights;
    });
  };

  const measureNotification = useCallback(
    (id: string, element: HTMLDivElement | null) => {
      notificationRefs.current[id] = element;
      if (element) {
        const height = element.offsetHeight;
        setNotificationHeights((prev) => ({
          ...prev,
          [id]: height,
        }));
      }
    },
    []
  );

  // Calculate cumulative bottom position for each notification
  const getBottomPosition = (currentIndex: number) => {
    let totalHeight = 16; // Base padding

    for (let i = 0; i < currentIndex; i++) {
      const notification = notifications[i];
      const height = notificationHeights[notification.id] || 80; // Default height fallback
      totalHeight += height + 12; // Height + gap between notifications
    }

    return totalHeight;
  };

  return (
    <div className="fixed bottom-0 left-3 right-3 sm:left-4 sm:right-auto z-50 pointer-events-none">
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          className="pointer-events-auto absolute"
          style={{
            bottom: `${getBottomPosition(index)}px`,
            zIndex: 1000 - index,
          }}
        >
          <NotificationToast
            message={notification.message}
            type={notification.type}
            duration={notification.duration}
            onClose={() => handleCloseNotification(notification.id)}
            onMount={(element) => measureNotification(notification.id, element)}
            downloadUrl={notification.downloadUrl}
            filename={notification.filename}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
